import PortfolioModelEdit from 'src/javascripts/components/PortfolioModelEdit';
import PortfolioModelOptimizer from 'src/javascripts/components/PortfolioModelOptimizer';

export default class PortfoliosModelsEdit {

  constructor() {}

  render() {

  	// JS for optimizer or normal modeling  	
  	if ($('#optimizerFilters').length !== 0) {
    	PortfolioModelOptimizer();
  	} else {
    	PortfolioModelEdit();
    }

  }

}
